export const QboAppSettingKeys = {
  QBO_ASSET_ACCOUNT_REF: 'QBO_ASSET_ACCOUNT_REF',
  QBO_INCOME_ACCOUNT_REF: 'QBO_INCOME_ACCOUNT_REF',
  QBO_EXPENSE_ACCOUNT_REF: 'QBO_EXPENSE_ACCOUNT_REF',
  QBO_DISCOUNT_ACCOUNT_REF: 'QBO_DISCOUNT_ACCOUNT_REF',
  QBO_SHIPPING_LINE_ITEM: 'QBO_SHIPPING_LINE_ITEM',
  QBO_PO_NUMBER_DEFINITION_ID: 'QBO_PO_NUMBER_DEFINITION_ID',
  QBO_INVENTORY_ADJUSTMENT_ACCOUNT_REF: 'QBO_INVENTORY_ADJUSTMENT_ACCOUNT_REF',
  QBO_INTEGRATION: 'QBO_INTEGRATION',
}
